import { useRouteMatch } from "react-router-dom";
import { FlowAddPaymentMethod } from "../../Settings/components/payment/FlowAddPaymentMethod";
import { useOnboardignModules } from "../Context";
import { OnboardingModulePaymentMethod } from "../types";

import { FlowStep } from "../../../shared/components/FlowSwitch/types";

export const PaymentMethod: React.FC<FlowStep> = props => {
  const match = useRouteMatch();
  const modules = useOnboardignModules();
  const onboardingModule = modules.find(m => m.type === "payment_method") as
    | OnboardingModulePaymentMethod
    | undefined;

  return (
    <FlowAddPaymentMethod
      basePath={match.path}
      onNext={props.onNext}
      availableMethods={onboardingModule?.allowedMethods}
    />
  );
};
